import type { NocModule } from "@seagames/contracts";
import { useQuery } from "@tanstack/react-query";
import { meQueryOptions } from "../auth/session";
import { nocModuleOpenFor } from "./access";

/**
 * Whether `module` is open for the signed-in session (`/auth/me.noc_stage`;
 * always true for every role but ORGANIZATION). For a component on an open
 * page that reads ANOTHER module's endpoint: skip the query and hide that
 * part until the stage opens it, instead of collecting a 403 STAGE_LOCKED.
 * Where the session is already at hand, `nocModuleOpenFor(session, …)`.
 */
export function useNocModuleOpen(module: NocModule): boolean {
	const me = useQuery(meQueryOptions);
	return me.data ? nocModuleOpenFor(me.data, module) : false;
}
